import React from "react";

import { styled } from "@mui/system";
import { StyledButton } from "../common/button.styled";

const StyledSeeProjectsButton = styled(StyledButton)(() => ({}));

export { StyledSeeProjectsButton };
